<template>
  <div class="ma-5">
    <v-row>
      <v-col cols="12">
        <v-btn
          class="btn-secondary float-right"
          text
          @click="drawer = true"
        >
          <v-icon>mdi-filter-variant</v-icon>
          Filtrar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Skeleton Loader -->
    <v-row v-if="loading">
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <v-skeleton-loader
          type="image"
          height="88px"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-skeleton-loader
          type="image"
          min-height="400"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-skeleton-loader
          type="image"
          min-height="400"
        />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Quantidade de operações"
          :value="operations.length"
          icon
          :color="iconType.INTEGER.COLOR"
          :icon-class="iconType.INTEGER.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Clientes ativos"
          :value="activeCustomers.length"
          icon
          :color="iconType.INTEGER.COLOR"
          :icon-class="iconType.INTEGER.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Clientes aprovados"
          :value="approvedCustomers.length"
          icon
          :color="iconType.INTEGER.COLOR"
          :icon-class="iconType.INTEGER.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Clientes totais"
          :value="customerCount"
          icon
          :color="iconType.INTEGER.COLOR"
          :icon-class="iconType.INTEGER.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Spread Médio"
          :value="`${averageSpreadValue || 0}%`"
          icon
          :color="iconType.PERCENT.COLOR"
          :icon-class="iconType.PERCENT.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Total Operado"
          :value="sumSubtotal | formatCurrency"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Lucro do Corban"
          :value="sumAgentValue || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Lucro do Corban Indicador"
          :value="sumIndicatorValue || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Lucro do Corban Master"
          :value="sumCambioHojeComissionValue || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Lucro do Banco"
          :value="sumBankComissionValue || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Operação média"
          :value="averageOperationValue || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="3"
        class="pa-2"
      >
        <CardDashboard
          description="Lucro bruto"
          :value="sumGrossProfit || 0 | formatCurrency()"
          icon
          :color="iconType.CURRENCY.COLOR"
          :icon-class="iconType.CURRENCY.ICON"
        />
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="6"
        class="pa-2"
      >
        <v-card class="card-cambio card-chart">
          <highcharts :options="valueOperatedPerBankChartOptions" />
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="6"
        class="pa-2"
      >
        <v-card class="card-cambio card-chart">
          <highcharts :options="valueOperatedPerCurrencyChartOptions" />
        </v-card>
      </v-col>
    </v-row>

    <v-navigation-drawer
      v-model="drawer"
      bottom
      fixed
      temporary
      right
      :width="500"
    >
      <v-list nav>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">Filtro</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list-item>
        <v-list-item-content>
          <v-form id="filters-form">
            <v-row>
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-autocomplete
                  label="Moeda"
                  v-model="filters.currencyId"
                  :items="currencyList"
                  item-text="name"
                  item-value="id"
                  clearable
                  dense
                  outlined
                  v-disabled-icon-focus
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-autocomplete
                  label="Período"
                  v-model="selectedDate"
                  :items="filterDateItems"
                  item-text="label"
                  item-value="value"
                  dense
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-autocomplete
                  label="Banco"
                  v-model="filters.bankList"
                  :items="bankList"
                  item-text="fantasyName"
                  item-value="id"
                  clearable
                  dense
                  outlined
                  multiple
                  v-disabled-icon-focus
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-autocomplete
                  label="Tipo de Pessoa"
                  v-model="filters.idPersonType"
                  :items="personTypeList"
                  item-text="description"
                  item-value="id"
                  clearable
                  dense
                  outlined
                  v-disabled-icon-focus
                />
              </v-col>
            </v-row>
          </v-form>
        </v-list-item-content>
      </v-list-item>

      <template #append>
        <v-list-item>
          <v-list-item-content>
            <v-row>
              <v-col
                cols="6"
                class="d-flex justify-center"
              >
                <v-btn
                  class="btn-tertiary"
                  width="100%"
                  text
                  @click="resetFilters"
                >
                  Limpar
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="d-flex justify-center"
              >
                <v-btn
                  class="btn-primary"
                  text
                  width="100%"
                  @click="filter"
                >
                  Filtrar
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
//Apis
import dashboardApi from '@/api/generic/dashboard-api';
import apiCurrency from '@/api/spread/currency-api';
import apiExchangeBank from '@/api/exchangeBank/exchange-bank-api';

//Models
import OperationFiltersModel from '@/model/operation-filters-model';
import CurrencyModel from '@/model/currency-model';
import ExchangeBankModel from '@/model/exchange-bank-model';

import DashboardOperationModel from '@/model/dashboard/dashboard-operation-model';
import DashboardCustomerExchangeBankModel from '@/model/dashboard/dashboard-customer-exchange-bank-model';
import DashboardCountModel from '@/model/dashboard/dashboard-count-model';

// Structs
import ChartDataStruct from '@/plugins/highcharts/chart-data-struct';

// Utils
import numberUtils from '../../../../common/utils/number';

//Components
import CardDashboard from '@/components/dashboard/CardDashboard.vue';

// Constants
import { PERSON_TYPE } from '@/constants/general-constants';
import { OPERATION_WORKFLOW } from '../../../../common/workflows/operationWorkflow';
import { CUSTOMER_EXCHANGE_BANK_WORKFLOW } from '../../../../common/workflows/customerExchangeBankWorkflow';
import {
  FILTER_ITEMS,
  FILTER_TYPE,
  CHART_COLORS,
  ICON_TYPE
} from '@/constants/dashboard-constants';

export default {
  name: 'Dashboard',
  components: { CardDashboard },
  data() {
    return {
      drawer: false,
      loading: true,

      filters: new OperationFiltersModel(),

      currencyList: [],
      bankList: [],

      operations: [],
      exchangeBanksDistinctCustomers: [],
      customerCount: 0,

      personTypeList: PERSON_TYPE,
      filterDateItems: FILTER_ITEMS,
      iconType: ICON_TYPE,

      selectedDate: FILTER_TYPE.THIS_MONTH,

      valueOperatedPerCurrencyChartOptions: new Object(),
      valueOperatedPerBankChartOptions: new Object()
    };
  },
  mounted() {
    this.filters = new OperationFiltersModel({
      statusList: [OPERATION_WORKFLOW.LIQUIDADA.id],
      exchangeTypeId: 1,
      startDate: this.selectedDate.START_DATE,
      endDate: this.selectedDate.END_DATE
    });

    Promise.all([
      this.getOperations(),
      this.getCustomerExchangeBanksDistinctCustomerList(),
      this.getCustomerCount(),
      this.getCurrencies(),
      this.getBankList()
    ])
      .then(() => {
        this.loadValueOperatedPerCurrencyChart();
        this.loadValueOperatedPerBankChart();
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    sumSubtotal() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.operationSubTotal) || 0);
      }, 0);
    },
    sumGrossProfit() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.grossProfit) || 0);
      }, 0);
    },
    sumAgentValue() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.agentValue) || 0);
      }, 0);
    },
    sumIndicatorValue() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.indicatorValue) || 0);
      }, 0);
    },
    sumCambioHojeComissionValue() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.cambioHojeComissionValue) || 0);
      }, 0);
    },
    sumBankComissionValue() {
      return this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.administrative.bankComissionValue) || 0);
      }, 0);
    },
    averageSpreadValue() {
      const sumSpreadValue = this.operations.reduce((acc, operation) => {
        return acc + (parseFloat(operation.spread) || 0);
      }, 0);

      const averageSpread = sumSpreadValue / this.operations.length;

      return averageSpread ? averageSpread.toFixed(2) : 0;
    },
    approvedCustomers() {
      return this.exchangeBanksDistinctCustomers.filter(
        (e) => e.status.id === CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_APROVADO.id
      );
    },
    activeCustomers() {
      const customerIdList = this.operations.map(({ customer }) => customer.id);

      return [...new Set(customerIdList)];
    },
    averageOperationValue() {
      const value = this.sumSubtotal / this.operations.length;

      return value ? value.toFixed(2) : 0;
    },
    currencyOperatedValue() {
      return Object.values(
        this.operations.reduce((acc, item) => {
          const id = item.currency.id;
          const operationSubTotal = parseFloat(item.administrative.operationSubTotal);

          if (!acc[id]) {
            acc[id] = { id, operationSubTotal: 0 };
          }

          acc[id].operationSubTotal += operationSubTotal;

          return acc;
        }, {})
      );
    },
    bankOperatedValue() {
      return Object.values(
        this.operations.reduce((acc, item) => {
          const id = item.bank.id;
          const operationSubTotal = parseFloat(item.administrative.operationSubTotal);

          if (!acc[id]) {
            acc[id] = { id, operationSubTotal: 0 };
          }

          acc[id].operationSubTotal += operationSubTotal;

          return acc;
        }, {})
      );
    },
    operatedPerCurrencyChartData() {
      const currencyMap = this.currencyOperatedValue.reduce((map, administrative) => {
        map[administrative.id] = administrative.operationSubTotal;

        return map;
      }, {});

      return this.currencyList.map((c) => {
        const operationSubTotal = currencyMap[c.id] || 0;

        return new ChartDataStruct({
          name: c.name,
          data: [new ChartDataStruct({ y: operationSubTotal, name: 'Total acumulado:' })]
        });
      });
    },
    operatedPerBankChartData() {
      const bankMap = this.bankOperatedValue.reduce((map, cv) => {
        map[cv.id] = cv.operationSubTotal;

        return map;
      }, {});

      return this.bankList.map((c) => {
        const operationSubTotal = bankMap[c.id] || 0;

        return new ChartDataStruct({ y: operationSubTotal, name: c.fantasyName });
      });
    }
  },
  filters: {
    formatCurrency(value, code, precison) {
      code = code || 'BRL';

      return numberUtils.formatCurrency(code, value, precison);
    }
  },
  methods: {
    getOperations() {
      return dashboardApi
        .getOperations(this.filters)
        .then(({ data }) => {
          this.operations = data.map((o) => new DashboardOperationModel(o));
        })
        .catch((error) => {
          if (error.response.status !== 404) {
            this.sendMessage((error.response && error.response.data.mensagem) || error, 'error');
          }

          this.operations = [];
        });
    },

    getCustomerExchangeBanksDistinctCustomerList() {
      return dashboardApi
        .getCustomerExchangeBanksDistinctCustomer(this.filters)
        .then(({ data }) => {
          this.exchangeBanksDistinctCustomers = data.map(
            (c) => new DashboardCustomerExchangeBankModel(c)
          );
        })
        .catch((error) => {
          this.sendMessage((error.response && error.response.data.mensagem) || error, 'error');
        });
    },

    getCustomerCount() {
      return dashboardApi
        .getCustomerCount()
        .then(({ data }) => {
          const dashboardCountModel = new DashboardCountModel(data);
          this.customerCount = dashboardCountModel.count;
        })
        .catch((error) => {
          this.sendMessage((error.response && error.response.data.mensagem) || error, 'error');
        });
    },

    getCurrencies() {
      return apiCurrency
        .findAll()
        .then(({ data }) => {
          this.currencyList = data.map((c) => new CurrencyModel(c));
        })
        .catch((error) => {
          this.sendMessage((error.response && error.response.data.mensagem) || error, 'error');
        });
    },
    getBankList() {
      return apiExchangeBank
        .findAll()
        .then(({ data }) => {
          this.bankList = data.map((b) => new ExchangeBankModel(b));
        })
        .catch((error) => {
          this.sendMessage((error.response && error.response.data.mensagem) || error, 'error');
        });
    },

    filter() {
      this.drawer = false;
      this.loading = true;

      this.filters.startDate = this.selectedDate.START_DATE;
      this.filters.endDate = this.selectedDate.END_DATE;

      Promise.all([this.getCustomerExchangeBanksDistinctCustomerList(), this.getOperations()])
        .then(() => {
          this.loadValueOperatedPerBankChart();
          this.loadValueOperatedPerCurrencyChart();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetFilters() {
      this.selectedDate = FILTER_TYPE.THIS_MONTH;
      this.filters = new OperationFiltersModel({
        statusList: [OPERATION_WORKFLOW.LIQUIDADA.id],
        exchangeTypeId: 1,
        startDate: this.selectedDate.START_DATE,
        endDate: this.selectedDate.END_DATE
      });
      this.filter();
    },

    loadValueOperatedPerCurrencyChart() {
      this.valueOperatedPerCurrencyChartOptions = {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Roboto'
          }
        },
        title: {
          text: 'Total acumulado por moeda',
          style: {
            fontFamily: 'Roboto',
            align: 'center',
            fontWeight: 600,
            color: 'gray'
          }
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            format: 'R$ {value:,.2f}'
          }
        },
        xAxis: {
          crosshair: false,
          tickLength: 0,
          labels: {
            enabled: false
          }
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            showInLegend: true,
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              inside: true,
              verticalAlign: 'top',
              pointFormatter: function () {
                return numberUtils.formatCurrency('BRL', this.y);
              },
              y: 10,
              style: {
                fontSize: '12px',
                fontFamily: 'Roboto'
              }
            }
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormatter: function () {
            return `${this.series.name}: ${numberUtils.formatCurrency('BRL', this.y)}`;
          }
        },
        series: this.operatedPerCurrencyChartData,
        colors: CHART_COLORS
      };
    },
    loadValueOperatedPerBankChart() {
      this.valueOperatedPerBankChartOptions = {
        chart: {
          type: 'pie',
          style: {
            fontFamily: 'Roboto'
          }
        },
        title: {
          text: 'Percentual operado por banco',
          style: {
            fontFamily: 'Roboto',
            align: 'center',
            fontWeight: 600,
            color: 'gray'
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormatter: function () {
            return `${this.series.name}: ${numberUtils.formatCurrency('BRL', this.y)}`;
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f} %',
              distance: -50,
              filter: {
                property: 'percentage',
                operator: '>',
                value: 4
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: 'Total operado',
            data: this.operatedPerBankChartData,
            colors: CHART_COLORS
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.card-chart {
  padding: 0 16px;
}
::v-deep .highcharts-background {
  fill: transparent;
}
</style>
